import { Canvas, useFrame, extend, useThree } from '@react-three/fiber';
import * as THREE from 'three';

import Palais from "/assets/Palais"
import Trees from "/assets/Trees"
import Builds from "/assets/Builds"
import Bancs from "/assets/Bancs"
import Publics from "/assets/Publics"
import Grilles from "/assets/Grilles"
import Ground from '/assets/Ground'
import WindStreaks from '/components/WindStreaks'
import Tele from '/components/Tele'




export default function BaseScene () {
    return (
       <>
            <directionalLight
                intensity={8}
                color="white"
                position={[-24, 14, -1]}
                castShadow
                shadow-mapSize-width={1024}
                shadow-mapSize-height={1024}
                shadow-camera-near={0.1}
                shadow-camera-far={500}
                shadow-camera-left={-500}
                shadow-camera-right={500}
                shadow-camera-top={500}
                shadow-camera-bottom={-500}
            />
            <Palais scale={[1, 1, 1]} />
            <Trees />
            <Builds />
            <Grilles />
            <Ground />
            <Bancs />
            <Tele />
            <WindStreaks />
            <Publics />
       </>
    );
 };
